<template>
  <div
    class="sb-filters-panel-text"
    data-sb-automation="sb-filters-panel-text-input"
  >
    <SbDropdown
      v-if="hasOperators && dsComponentDetails.version === VersionOptions.LEGACY"
      v-model:value="selectedOperator"
      :options="operatorsList"
      :results-limit="6"
      v-bind="filter.operatorProps"
    >
      <template #selection="scope">
        <sb-selected-option>
          <sb-text :value="scope?.selected?.name" />
        </sb-selected-option>
      </template>
      <sb-options class="operator-options">
        <template #default="scope">
          <sb-option :value="scope?.option">
            <sb-text :value="scope?.option?.name" />
          </sb-option>
        </template>
      </sb-options>
    </SbDropdown>
    <sb-select
      v-if="hasOperators && dsComponentDetails.version !== VersionOptions.LEGACY"
      v-model="internalOperator"
      v-bind="filter.operatorProps"
      :options="operatorsList"
      option-label="name"
      option-value="key"
      :results-limit="6"
    />
    <SbNumberInput
      v-if="filter.type == 'number'"
      v-model:value="internalValue"
      :version="dsComponentDetails.version"
      :nullable="true"
      v-bind="filter.props"
      fluid
    />
    <SbTextArea
      v-else-if="filter.type === 'textarea'"
      v-model:value="internalValue"
      :version="dsComponentDetails.version"
      :class="$style.filterPanelTextArea"
      v-bind="filter.props"
      fluid
    />
    <SbTextInput
      v-else
      v-model:value="internalValue"
      :version="dsComponentDetails.version"
      v-bind="filter.props"
      fluid
    />
  </div>
</template>
<script>
import SbDropdown from '@src/components/Dropdown/SbDropdown.vue';
import SbOption from '@src/components/Dropdown/components/SbOption.vue';
import SbOptions from '@src/components/Dropdown/components/SbOptions.vue';
import SbTextInput from '@src/components/Input/SbTextInput.vue';
import SbNumberInput from '@src/components/Input/SbNumberInput.vue';
import SbSelectedOption from '@src/components/Dropdown/components/SbSelectedOption.vue';
import SbText from '@src/components/Text/SbText.vue';
import SbTextArea from '@src/components/Input/SbTextArea.vue';
import SbSelect from '@src/components/Select/SbSelect.vue';
import { versionedComponentsMixin } from '@src/mixins/versionedComponents';

export default {
  name: 'SbCollapsableText',
  components: {
    SbDropdown,
    SbNumberInput,
    SbOption,
    SbOptions,
    SbSelectedOption,
    SbTextInput,
    SbText,
    SbTextArea,
    SbSelect,
  },
  mixins: [versionedComponentsMixin],
  props: {
    filter: {
      type: Object,
      required: true,
    },
    filterValue: {
      type: Object,
      default: () => { },
    },
  },
  emits: ['update:filter-value'],
  computed: {
    internalValue: {
      get() {
        return this.filterValue?.value ?? this.filter.default;
      },
      set(value) {
        this.$emit('update:filter-value', {
          operator: this.internalOperator,
          value,
        });
      },
    },
    selectedOperator: {
      get() {
        const value = this.internalOperator;
        return this.operatorsList.find((x) => x.key === value);
      },
      set(operator) {
        this.internalOperator = operator.key;
      },
    },
    internalOperator: {
      get() {
        return this.filterValue?.operator ?? this.filter.defaultOperator;
      },
      set(value) {
        this.$emit('update:filter-value', {
          operator: value,
          value: this.internalValue,
        });
      },
    },
    hasOperators() {
      return this.filter && this.filter.operators?.length;
    },
    operatorsList() {
      return this.filter.operators;
    },
  },
};
</script>

<style lang="scss" module>
.filterPanelTextArea {
  min-height: 15.625rem;
}
</style>
